module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-08.4caa3c24.png";